// Translation map for static site content
// English to ʻŌlelo Hawaiʻi translations

export const translations = {
  english: {
    // Navbar
    'kumu_connect': 'Kumu Connect',
    'beta': 'beta',
    'olelo': 'ʻŌlelo',
    'english': 'English',
    'logout': 'Logout',

    // Sidebar
    'dashboard': 'Dashboard',
    'tools': 'Tools',
    'generate_quiz': 'Generate Quiz',
    'my_plans': 'My Plans',
    'generated_material': 'Generated Material',
    'resources': 'Resources',
    'about_help': 'About & Help',
    'feedback': 'feedback',

    // Dashboard
    'learning_that_connects': 'Learning That Connects',
    'welcome_message': 'Welcome Message Intro',
    'welcome_pilot_intro': 'Welcome to the Kumu Connect Pilot Program! New here? Watch the intro video:',
    'read_about_beta': 'Read about beta testing',
    'read_about_beta_btn': 'Read About Beta Testing',
    'create_lesson_plan': 'Create Lesson Plan',
    'create_lesson_plan_desc': 'Create a lesson plan, with scripts, worksheets, activities, and more using AI.',
    'augment_lessons_plan': 'Augment Lessons Plan',
    'augment_lessons_plan_desc': 'Upload an existing lesson plan, and adjust, translate, level and more using AI.',
    'ai_assisted': 'AI-Assisted',
    'recent_lesson_plans': 'Recent Lesson Plans',
    'recent_generated_quizzes': 'Recent Generated Quizzes',
    'subject': 'Subject',
    'language': 'Language',
    'grade': 'Grade',
    'sort_by': 'sort by:',
    'priority': 'Priority',
    'standard_code': 'Standard Code',
    'view_all_lessons': 'View all lessons plans',
    'view_all_quizzes': 'View all quizzes',
    'understanding_computer_parts': 'Understanding Computer Parts',
    'lesson_description': 'Lesson Description',
    'completed_lesson_plans': 'Completed Lesson Plans',
    'in_progress_lesson_plans': 'In Progress Lesson Plans',
    'delete': 'Delete',
    'delete_lesson_plan': 'Delete Lesson Plan',
    'delete_confirmation_message': 'Delete Confirmation',
    'delete_warning': 'Delete Warning',
    'cancel': 'Cancel',
    'success': 'Success',
    'error': 'Error',
    'ok': 'OK',
    'pdf_saved_success': 'PDF saved successfully',
    'pdf_save_error': 'PDF save error',
    'pdf_generation_error': 'PDF generation error',
    'open_in_drive': 'Open in Drive',
    'edit': 'Edit',
    'all': 'All',
    'most_recent': 'Most Recent',
    'oldest': 'Oldest',
    'title_a_z': 'Title A-Z',
    'title_z_a': 'Title Z-A',
    'status': 'Status',

    // View Lesson Plan
    'grade_level': 'Grade Level',
    'concept_label': 'Concept',
    'subconcept_label': 'Subconcept',
    'standard_label': 'Standard',
    'standard_description_label': 'Standard Description',
    'language_label': 'Language',
    'save_pdf_to_drive': 'Save PDF to Drive',
    'print': 'Print',
    'saving': 'Saving...',
    'loading_lesson_plan': 'Loading lesson plan...',
    'load_lesson_plan_error': 'Load lesson plan error',
    'enter_lesson_plan_title': 'Enter lesson plan title',
    'save': 'Save',
    'loading_lesson_plans': 'Loading lesson plans...',
    'save_lesson_plan_to_dashboard': 'Save Lesson Plan to Dash',
    'give_lesson_plan_name': 'Give lesson plan name',
    'enter_lesson_plan_name': 'Enter lesson plan name',
    'characters': 'characters',
    'save_to_dashboard': 'Save to Dashboard',
    'generations_remaining': 'Generations Remaining',
    'generations_left': 'Generations Left',
    'creations_left': 'Creations Left',
    'piloting_stats': 'Piloting stats',
    'feedbacks_submitted': 'Feedbacks submitted',
    'pilot_testing_title': 'Kumu Connect Pilot Testing',
    'pilot_testing_intro': "By being part of Kumu Connect Pilot Testing, you're helping us improve Kumu Connect's outputs to better serve our keiki and kumu!",
    'earn_free_creations': 'Earn Free Creations',
    'earn_free_creations_desc': 'Your first 10 creations are on us! Earn 10 more creations for each feedback survey you fill out.',
    'get_rewarded': 'Get Rewarded!',
    'get_rewarded_desc': 'Submit 5 feedback surveys to receive $10 gift card as a thank you for helping us improve!',
    'what_kind_of_feedback': 'What Kind Of Feedback?',
    'what_kind_of_feedback_intro': "Some of the feedback we're looking for includes:",
    'report_bugs': 'Report Bugs And Issues',
    'translation_suggestions': 'Translation Suggestions',
    'feature_requests': 'Feature Requests',
    'your_piloting_stats': 'Your Piloting Stats',
    'feedback_survey_btn': 'Feedback Survey',
    'no_generations_left': 'No generations remaining',
    'you_have_generations': 'You have {count} left',

    // Select Elements
    'select_elements_title': 'Choose cultural connections for your lesson plan',
    'select_elements_subtitle': 'Choose what helps your students connect best or feel free to add your own story by clicking the button on the right!',
    'use_my_story': 'Use My Story',
    'use_my_story_line1': "Already know what story, practice, or proverb you'd like to use?",
    'use_my_story_line2': "Describe it to Kumu Connect's AI helper to use them in the lesson!",
    'lesson_creator': 'Lesson Creator',
    'lesson_info': 'Lesson Info',
    'connections': 'Connections',
    'lesson_editor': 'Lesson Editor',
    'story': 'Moʻolelo',
    'proverb': 'ʻŌlelo Noʻeau',
    'cultural_practice': 'Cultural Practice',
    'create_lesson_plan_title': 'Create a Lesson Plan',
    'create_lesson_plan_subtitle': 'Select the information for your new lesson plan',
    'subconcept': 'Subconcept',
    'computer_science': 'Computer Science',
    'mathematics': 'Mathematics',
    'science': 'Science',
    'select_option': '- Select -',
    'olelo_hawaii_hawaiian': 'ʻŌlelo Hawaiʻi (Hawaiian)',
    'about_help_title': 'About & Help',
    'about_help_subtitle': 'Learn how Kumu Connect works and where to reach us when you need support.',
    'about_help_overview_title': 'Platform Overview',
    'about_help_overview_body': 'Kumu Connect supports teachers in building standards-aligned lesson plans grounded in Moʻolelo, ʻŌlelo Noʻeau, and Hawaiian cultural practices. The platform is co-designed with educators to reduce prep time while preserving cultural and pedagogical integrity.',
    'about_help_pill_ai': 'AI-Assisted',
    'about_help_pill_cultural': 'Culturally Grounded',
    'about_help_pill_standards': 'Standards Aligned',
    'about_help_faq_title': 'Frequently Asked Questions',
    'about_help_faq_q1': 'What makes Kumu Connect different from other AI lesson tools?',
    'about_help_faq_a1': 'Kumu Connect centers Hawaiian context, cultural relevance, and standards alignment from the start. It was built for real classroom use with immersion and local educators.',
    'about_help_faq_q2': 'How was Kumu Connect developed?',
    'about_help_faq_a2': 'It was co-designed by researchers, technologists, educators, and cultural specialists, then refined through classroom-informed feedback and pilot testing.',
    'about_help_faq_q3': 'How do you protect sacred or sensitive knowledge?',
    'about_help_faq_a3': 'Kumu Connect follows community-informed guardrails and Indigenous data sovereignty values, with careful boundaries around what should and should not be digitized.',
    'about_help_walkthrough_title': 'How To Use Kumu Connect',
    'about_help_step1_title': 'Dashboard',
    'about_help_step1_body': 'Log in to land on your dashboard. You can see your generations counter, completed lesson plans, and in-progress lesson plans. Click "Create Lesson Plan" to begin.',
    'about_help_step2_title': 'Lesson Plan Form',
    'about_help_step2_body': 'Choose Subject, Grade, Concept, and Subconcept. The standard auto-populates from those selections. Choose language (English or ʻŌlelo Hawaiʻi), optionally select a Moku, then click Next for cultural verification.',
    'about_help_step3_title': 'Select Cultural Elements',
    'about_help_step3_body': 'Review the three generated elements: Moʻolelo, ʻŌlelo Noʻeau, and Cultural Practice. You can expand cards, regenerate content, select or deselect elements (at least one is required), or add your own through Kōkua Chat. Then generate the lesson plan.',
    'about_help_step4_title': 'Display & Edit Lesson Plan',
    'about_help_step4_body': 'Your generated lesson appears in the editor. Use the left table of contents to jump between sections. Use AI Chat on the right to request edits and review diffs before applying changes. Edit directly and save with a lesson title.',
    'about_help_step5_title': 'View Lesson Plan',
    'about_help_step5_body': 'Open the read-only lesson view to review the final version. Use Edit to return to the editor. At the bottom, choose Save PDF to Google Drive or Print to open your browser print flow.',
    'about_help_step6_title': 'Back On Dashboard',
    'about_help_step6_body': 'Your saved lesson appears under Completed Lesson Plans. You can filter by Subject, Language, and Grade; sort by recent, oldest, or title; reopen any card; or use the three-dot menu to delete.',
    'about_help_feedback_title': 'Feedback & Pilot Program',
    'about_help_feedback_body': 'Feedback forms help us improve lesson quality, translation quality, and usability. During pilot testing, feedback also contributes to your generation rewards.',
    'about_help_feedback_point1': 'Use the Feedback button to report bugs, suggest features, and share translation improvements.',
    'about_help_feedback_point2': 'Each submitted feedback survey can unlock additional generations in pilot mode.',
    'about_help_feedback_point3': 'Detailed feedback with screenshots and lesson context helps our team resolve issues faster.',
    'about_help_need_help_title': 'Need Help?',
    'about_help_need_help_body': 'Email our team and include your lesson plan ID or screenshot when possible.',
  },
  olelo: {
    // Navbar
    'kumu_connect': 'Kumu Connect',
    'beta': 'beta',
    'olelo': 'ʻŌlelo',
    'english': 'English',
    'logout': 'Haʻalele',

    // Sidebar
    'dashboard': 'Papahana',
    'tools': 'Lako',
    'generate_quiz': 'Haku i kuisa',
    'my_plans': 'Kaʻu Haʻawina',
    'generated_material': 'Waihona Haku ʻia',
    'resources': 'Kumuwaiwai',
    'about_help': 'Kōkua',
    'feedback': 'manaʻo',

    // Dashboard
    'learning_that_connects': 'Ka Hoʻonaʻauao e Hoʻopili',
    'welcome_message': 'E komo mai i ka Papahana Hoʻomaʻamaʻa o Kumu Connect! He mea hou? E nānā i ke kiʻiʻoniʻoni hoʻomaka:',
    'welcome_pilot_intro': 'E komo mai i ka Kumu Connect Pilot Program! He mea hou? E nānā i ke kiʻiʻoniʻoni hoʻomaka:',
    'read_about_beta': 'Heluhelu e pili ana i ka hoʻomaʻamaʻa',
    'read_about_beta_btn': 'Heluhelu e pili ana i ka Beta Testing',
    'create_lesson_plan': 'Haku i haʻawina',
    'create_lesson_plan_desc': 'Haku i haʻawina, me nā palapala, nā pepa hana, nā hana, a me nā mea ʻē aʻe me ka AI.',
    'augment_lessons_plan': 'Hoʻololi i ka Haʻawina',
    'augment_lessons_plan_desc': 'Hoʻololi i ka haʻawina i loaʻa, a hoʻoponopono, unuhi, pae, a me nā mea ʻē aʻe me ka AI.',
    'ai_assisted': 'Kōkua AI',
    'recent_lesson_plans': 'Nā Haʻawina Hou',
    'recent_generated_quizzes': 'Nā Nīnau Hou i Haku ʻia',
    'subject': 'Kumuhana',
    'language': 'ʻŌlelo',
    'grade': 'Papa',
    'sort_by': 'Wae ma:',
    'priority': 'Hoʻomakakoho',
    'standard_code': 'Helu Ana Aʻo',
    'view_all_lessons': 'Nānā i nā haʻawina a pau',
    'view_all_quizzes': 'Nānā i nā kuisa a pau',
    'understanding_computer_parts': 'Ka Hoʻomaopopo ʻana i nā ʻĀpana Kamepiula',
    'lesson_description': 'He wehewehena o ka haʻawina.',
    'completed_lesson_plans': 'Nā Haʻawina i Paʻa',
    'in_progress_lesson_plans': 'Nā Haʻawina e haku ʻia nei',
    'delete': 'Holoi',
    'delete_lesson_plan': 'Holoi i ka Haʻawina',
    'delete_confirmation_message': 'Maopopo iā ʻoe e holoi ʻia ana kēia haʻawina?',
    'delete_warning': 'ʻAʻole hiki ke hoʻihoʻi i kēia hana.',
    'cancel': 'Kāpae',
    'success': 'Kō',
    'error': 'Hewa',
    'ok': 'Hiki',
    'pdf_saved_success': 'Ua mālama ʻia ka PDF i ka Google Drive!',
    'pdf_save_error': 'ʻAʻole hiki ke mālama i ka PDF i ka Google Drive. E hoʻāʻo hou.',
    'pdf_generation_error': 'ʻAʻole hiki ke hana i ka PDF. E hoʻāʻo hou.',
    'open_in_drive': 'Wehe i ka Drive',
    'edit': 'Hoʻoponopono',
    'all': 'Nā Mea A Pau',
    'most_recent': 'Ka Mea Hou Loa',
    'oldest': 'Ka Mea Kahiko Loa',
    'title_a_z': 'Inoa A-Z',
    'title_z_a': 'Inoa Z-A',
    'status': 'Kūlana',

    // View Lesson Plan
    'grade_level': 'Papa',
    'concept_label': 'Kumu Manaʻo',
    'subconcept_label': 'Kumu Manaʻo Hāiki',
    'standard_label': 'Ana Aʻo',
    'standard_description_label': 'Wehewehena o ke Ana Aʻo',
    'language_label': 'ʻŌlelo',
    'save_pdf_to_drive': 'Mālama PDF i ka Drive',
    'print': 'Paʻi',
    'saving': 'Ke mālama nei...',
    'loading_lesson_plan': 'Ke hoʻouka nei i ka haʻawina...',
    'load_lesson_plan_error': 'ʻAʻole hiki ke hoʻouka i kēia haʻawina. E hoʻāʻo hou mai "Kaʻu Papahana".',
    'enter_lesson_plan_title': 'E kākomo i ka inoa o ka haʻawina',
    'save': 'Mālama',
    'loading_lesson_plans': 'Ke hoʻouka nei i nā haʻawina...',
    'save_lesson_plan_to_dashboard': 'Mālama i ka Haʻawina i ka Papahana',
    'give_lesson_plan_name': 'Kapa inoa i kāu haʻawina',
    'enter_lesson_plan_name': 'E kākomo i ka inoa o ka haʻawina',
    'characters': 'nā hua palapala',
    'save_to_dashboard': 'Mālama i ka Papahana',
    'generations_remaining': 'Nā Hana I Koe',
    'generations_left': 'Koe',
    'creations_left': 'Nā Hana I Koe',
    'piloting_stats': 'Nā helu pilot',
    'feedbacks_submitted': 'Nā manaʻo i hoʻouna ʻia',
    'pilot_testing_title': 'Kumu Connect Pilot Testing',
    'pilot_testing_intro': "Ma kou komo ʻana i ka Kumu Connect Pilot Testing, ke kōkua mai nei ʻoe iā mākou e hoʻomaikaʻi i nā huahana o Kumu Connect no kā mākou keiki a me nā kumu!",
    'earn_free_creations': 'Loaʻa nā Hana Manuahi',
    'earn_free_creations_desc': 'ʻO kāu 10 hana mua na mākou! Loaʻa 10 hana hou no kēlā me kēia nīnau manaʻo āu e hoʻopiha ai.',
    'get_rewarded': 'Loaʻa ka Makana!',
    'get_rewarded_desc': 'Hoʻouna i 5 nīnau manaʻo e loaʻa ka $10 gift card ma ke ʻano he mahalo no kou kōkua ʻana iā mākou!',
    'what_kind_of_feedback': 'He aha ke ʻano o ka Manaʻo?',
    'what_kind_of_feedback_intro': 'ʻO kekahi o nā manaʻo a mākou e ʻimi nei:',
    'report_bugs': 'Hoʻopaʻi i nā Pilikia a me nā Hihia',
    'translation_suggestions': 'Nā Manaʻo Unuhi',
    'feature_requests': 'Nā Nonoi Hana',
    'your_piloting_stats': 'Kāu Nā Helu Pilot',
    'feedback_survey_btn': 'Nīnau Manaʻo',
    'no_generations_left': 'ʻAʻohe hana i koe',
    'you_have_generations': 'He {count} hana koe iā ʻoe',

    // Select Elements
    'select_elements_title': 'E koho i nā pilina moʻomeheu no kāu papahana haʻawina',
    'select_elements_subtitle': 'E koho i ka mea e kōkua loa i kāu mau haumāna e pili ai, a i ʻole e hoʻohui i kāu moʻolelo ponoʻī ma ke kaomi ʻana i ke pihi ma ka ʻākau!',
    'use_my_story': 'E hoʻohana i kaʻu moʻolelo',
    'use_my_story_line1': 'Ua ʻike mua anei ʻoe i ka moʻolelo, ka hana, a i ʻole ka ʻōlelo noʻeau āu e makemake ai e hoʻohana?',
    'use_my_story_line2': 'E wehewehe iā Kumu Connect AI kōkua i hiki ke hoʻokomo ʻia i loko o ka haʻawina!',
    'lesson_creator': 'Mea Haku Haʻawina',
    'lesson_info': 'ʻIke Haʻawina',
    'connections': 'Nā Pilina',
    'lesson_editor': 'Mea Hoʻoponopono Haʻawina',
    'story': 'Moʻolelo',
    'proverb': 'ʻŌlelo Noʻeau',
    'cultural_practice': 'Hana Moʻomeheu',
    'create_lesson_plan_title': 'E Haku i Papahana Haʻawina',
    'create_lesson_plan_subtitle': 'E koho i ka ʻike no kāu papahana haʻawina hou',
    'subconcept': 'Kumu Manaʻo Hāiki',
    'computer_science': 'ʻEpekema Kamepiula',
    'mathematics': 'Makemakika',
    'science': 'ʻEpekema',
    'select_option': '- E koho -',
    'olelo_hawaii_hawaiian': 'ʻŌlelo Hawaiʻi',
    'about_help_title': 'Kōkua',
    'about_help_subtitle': 'E aʻo pehea e hana ai ʻo Kumu Connect a me kahi e launa ai me mākou inā pono ke kōkua.',
    'about_help_overview_title': 'Nānā Nui o ka Papahana',
    'about_help_overview_body': 'Kōkua ʻo Kumu Connect i nā kumu i ka haku ʻana i nā papahana haʻawina i kūlike me nā ana aʻo, a paʻa i ka moʻomeheu ma o ka Moʻolelo, ʻŌlelo Noʻeau, a me nā hana moʻomeheu Hawaiʻi. Ua kūkulu pū ʻia me nā kumu i mea e emi ai ka manawa hoʻomākaukau me ka mālama i ka pono aʻo a me ka pono moʻomeheu.',
    'about_help_pill_ai': 'Kōkua AI',
    'about_help_pill_cultural': 'Paʻa i ka Moʻomeheu',
    'about_help_pill_standards': 'Kūlike me nā Ana Aʻo',
    'about_help_faq_title': 'Nīnau Pinepine',
    'about_help_faq_q1': 'He aha ka mea kūikawā o Kumu Connect ma mua o nā mea hana AI ʻē aʻe no ka haʻawina?',
    'about_help_faq_a1': 'Kū pono ʻo Kumu Connect i ka pōʻaiapili Hawaiʻi, ka pili moʻomeheu, a me ka kūlike me nā ana aʻo mai ka hoʻomaka ʻana. Ua kūkulu ʻia ia no ka hoʻohana maoli i loko o ka lumi papa.',
    'about_help_faq_q2': 'Pehea i kūkulu ʻia ai ʻo Kumu Connect?',
    'about_help_faq_a2': 'Ua hana pū ʻia me nā mea noiʻi, nā loea ʻenehana, nā kumu, a me nā loea moʻomeheu, a laila ua hoʻomaikaʻi ʻia ma o ka manaʻo mai nā lumi papa a me ka pilot testing.',
    'about_help_faq_q3': 'Pehea e mālama ai i ka ʻike kapu a i ʻole ka ʻike koʻikoʻi?',
    'about_help_faq_a3': 'Mālama ʻo Kumu Connect i nā alakaʻi kaiāulu a me nā waiwai ea ʻike ʻōiwi, me nā palena maopopo no ka ʻike e pono ʻole e hoʻouka kikohoʻe.',
    'about_help_walkthrough_title': 'Pehea e hoʻohana ai iā Kumu Connect',
    'about_help_step1_title': 'Papahana Nui',
    'about_help_step1_body': 'E komo i loko a pae i ka dashboard. Ma laila e ʻike ai i ka helu hana i koe, nā haʻawina i pau, a me nā haʻawina e hana ʻia nei. Kaomi i "Haku i Haʻawina" e hoʻomaka.',
    'about_help_step2_title': 'Palapala Haʻawina',
    'about_help_step2_body': 'E koho i ke Kumuhana, Papa, Kumu Manaʻo, a me ke Kumu Manaʻo Hāiki. E hoʻopiha ʻia ka ana aʻo ma muli o ia mau koho. E koho i ka ʻōlelo (English a i ʻole ʻŌlelo Hawaiʻi), koho i ka Moku inā makemake ʻia, a laila kaomi i Next no ka hōʻoia moʻomeheu.',
    'about_help_step3_title': 'Koho i nā Pilina Moʻomeheu',
    'about_help_step3_body': 'E nānā i nā mea i haku mua ʻia ʻekolu: Moʻolelo, ʻŌlelo Noʻeau, a me ka Hana Moʻomeheu. Hiki ke hoʻonui i ke kāleka, hana hou i ka ʻike, koho a kāpae paha i nā mea (pono ma ka liʻiliʻi hoʻokahi), a i ʻole hoʻohui i kāu ponoʻī ma o Kōkua Chat. A laila e haku i ka haʻawina.',
    'about_help_step4_title': 'Nānā & Hoʻoponopono i ka Haʻawina',
    'about_help_step4_body': 'E ʻike ʻia ka haʻawina AI ma waena o ka mea hoʻoponopono. E hoʻohana i ka papa kuhikuhi ma ka ʻaoʻao hema e lele i nā ʻāpana. E hoʻohana i AI Chat ma ka ʻaoʻao ʻākau no nā noi hoʻoponopono a nānā i nā loli ma mua o ka ʻae ʻana. E mālama me ka inoa haʻawina.',
    'about_help_step5_title': 'Nānā i ka Haʻawina',
    'about_help_step5_body': 'Ma ka nānā heluhelu-wale nō, hiki ke hōʻoia i ka mana hope. Kaomi i Edit e hoʻi i ka hoʻoponopono. Ma lalo, hiki ke mālama i ka PDF i Google Drive a i ʻole paʻi.',
    'about_help_step6_title': 'Hoʻi i ka Dashboard',
    'about_help_step6_body': 'E hōʻike ʻia ka haʻawina i mālama ʻia ma lalo o Nā Haʻawina i Paʻa. Hiki ke kānana ma ke Kumuhana, ʻŌlelo, a me ka Papa; hoʻonohonoho ma ka mea hou loa, kahiko loa, a i ʻole ka inoa; wehe hou i nā kāleka; a holoi ma ka papa kuhikuhi kiko ʻekolu.',
    'about_help_feedback_title': 'Manaʻo & Pilot Program',
    'about_help_feedback_body': 'Kōkua nā palapala manaʻo iā mākou e hoʻomaikaʻi i ka maikaʻi o ka haʻawina, ka maikaʻi o ka unuhi, a me ka maʻalahi o ka hoʻohana. I ka wā pilot, kōkua pū ka manaʻo i kāu mau makana hana hou.',
    'about_help_feedback_point1': 'E hoʻohana i ke pihi Feedback no ka hōʻike pilikia, noi hiʻohiʻona hou, a me nā manaʻo unuhi.',
    'about_help_feedback_point2': 'Hiki i kēlā me kēia palapala manaʻo i hoʻouna ʻia ke wehe i nā hana hou i ka wā pilot.',
    'about_help_feedback_point3': 'ʻOi aku ka wikiwiki o ka hoʻoponopono a kā mākou hui inā hāʻawi ʻia ka screenshot a me ka pōʻaiapili o ka haʻawina.',
    'about_help_need_help_title': 'Pono Kōkua?',
    'about_help_need_help_body': 'E leka uila i kā mākou hui, a inā hiki e hoʻopili i ka ID haʻawina a i ʻole screenshot.',
  }
};

export const t = (key, language = 'english') => {
  return translations[language]?.[key] || translations.english[key] || key;
};
